export const getImgURL = (url: string) => {
    return url?.includes("digitaloceanspaces") ? url?.replace("digitaloceanspaces.com", "cdn.digitaloceanspaces.com") : process.env.REACT_APP_BACKEND_API_URL_DEV + url;
};